<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/commands/${bot}`">Commands</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.command }}
    </h1>
    <trashed-message v-if="command.deleted_at" class="mb-6" @restore="restore"> This command has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.command" :error="form.errors.command" class="pb-8 pr-6 w-full lg:w-1/2" label="Command" />
          <text-input v-model="form.api_url" :error="form.errors.api_url" class="pb-8 pr-6 w-full lg:w-1/2" label="URL" />
          <text-input v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-1/2" label="Note" />
          <label class="flex items-center mt-6 select-none" for="active">
            <input id="active" v-model="form.active" class="mr-1" type="checkbox" />
            <span class="text-sm">Active</span>
          </label>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!command.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Command</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Command</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    command: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        bot_id: window.location.pathname.split("/").slice(-3, -2)[0],
        command: this.command.command,
        api_url: this.command.api_url,
        note: this.command.note,
        active: !! this.command.active,
      }),
      bot: window.location.pathname.split("/").slice(-3, -2)[0],
    }
  },
  methods: {
    update() {
      this.form.put(`/commands/${this.bot}/${this.command.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this command?')) {
        this.$inertia.delete(`/commands/${this.bot}/${this.command.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this command?')) {
        this.$inertia.put(`/commands/${this.bot}/${this.command.id}/restore`)
      }
    },
  },
}
</script>
